import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton'; // Agregado para skeletons si se necesita

// Component
import { AgregarListaProductosMasivaModalComponent } from './agregar-lista-productos-masiva-modal.component';

@NgModule({
  declarations: [AgregarListaProductosMasivaModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ProgressSpinnerModule,
    TooltipModule,
    ChipModule,
    TableModule,
    SkeletonModule, // Agregado para skeletons
  ],
  exports: [AgregarListaProductosMasivaModalComponent],
})
export class AgregarListaProductosMasivaModalModule {}
